// Chakra imports
import { Flex, Text } from '@chakra-ui/react';

// Custom components
import {
	TbCircleLetterM
} from 'react-icons/tb';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
	return (
		<Flex alignItems='center' flexDirection='column'>
			<Text><TbCircleLetterM fontSize='100px' /></Text>
			<HSeparator mb='20px' />
		</Flex>
	);
}

export default SidebarBrand;
